import type { JsonBalanceAsset } from 'src/store/shared/balances/types';

import { BASE_TOKEN_COLOR_NUMBER, getPieColor, STABLES_COLOR_NUMBER } from 'src/store/utils/color';
import { getTotal } from 'src/store/utils/balances/calculations';
import { sumBy } from 'es-toolkit';

// Moved to @skynet/data-balances-helpers — re-exported here to keep existing import paths working.
export { getDoublingMap } from '@skynet/data-balances-helpers';

export const generatePieChartData = (assets: JsonBalanceAsset[]) => {
  const { value } = getTotal(assets, 'volumeUSD', {});
  const totalDuplicates = sumBy(assets, (asset) => asset.volumeUSD) ?? 0;

  return assets.map((asset) => {
    return {
      id: asset.token,
      label: asset.token,
      value: asset.volumeUSD,
      percentageValue:
        value > 0
          ? asset.volumeUSD / value
          : totalDuplicates > 0
            ? asset.volumeUSD / totalDuplicates
            : 0,
      color:
        asset.type === 1 ? getPieColor(BASE_TOKEN_COLOR_NUMBER) : getPieColor(STABLES_COLOR_NUMBER),
    };
  });
};
